import FooterBar from './FooterBar.vue';

export default FooterBar;
